import { Check, ErrorOutline } from '@mui/icons-material';
import {
    Grow, Paper, Popper, Typography
} from '@mui/material';
import { MouseEventHandler, ReactNode, useState } from 'react';

import styles from './CopyButton.module.scss';


interface CopyButtonProps {
    children: (params: {
        onClick: MouseEventHandler<HTMLElement>;
        open: boolean;
    }) => ReactNode;
    textToCopy: string;
    successMessage: string;
}

const transitionDuration = 250;

export function CopyButton({ children, textToCopy, successMessage }: CopyButtonProps) {
    const [ anchorEl, setAnchorEl ] = useState<HTMLElement>();
    const [ open, setOpen ] = useState(false);
    const [ error, setError ] = useState(false);

    return (
        <>
            {children({
                open,
                onClick: async (event) => {
                    setAnchorEl(event.currentTarget);

                    try {
                        await navigator.clipboard.writeText(textToCopy);
                    } catch (e) {
                        setError(true);
                    } finally {
                        setOpen(true);

                        setTimeout(() => {
                            setOpen(false);

                            if (error) {
                                setTimeout(() => {
                                    setError(false);
                                }, transitionDuration);
                            }
                        }, 3000);
                    }
                }
            })}

            <Popper
                className={styles.popper}
                open={open}
                anchorEl={anchorEl}
                transition
                children={({ TransitionProps }) => (
                    <Grow
                        {...TransitionProps}
                        timeout={250}
                    >
                        <Paper
                            className={styles.popperContent}
                            elevation={3}
                        >
                            {error ? (
                                <>
                                    <ErrorOutline color="error" />

                                    <Typography>
                                        Something went wrong while copying
                                    </Typography>
                                </>
                            ) : (
                                <>
                                    <Check color="success" />

                                    <Typography>
                                        {successMessage}
                                    </Typography>
                                </>
                            )}
                        </Paper>
                    </Grow>
                )}
            />
        </>
    );
}
